exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-leadgen-v2-Auth-Login-loginButton__loginButton--1Ba-s{margin-top:24px;font-family:'MuseoSans-500', sans-serif;letter-spacing:0px;background:white;width:80%;height:42px;border:1px solid #18C7AF;border-radius:30px;font-size:14px;color:#00d9bc}\n", ""]);

// Exports
exports.locals = {
	"loginButton": "src-components-leadgen-v2-Auth-Login-loginButton__loginButton--1Ba-s"
};